import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

import { SubscriptionPlanName } from '../../../../models/subscription-plan';
import { FlexComponent } from '../../../../ui-kit/flex/flex.component';
import { EarlyPayCalculatorPlanPlateComponent } from '../early-pay-calculator-plan-plate/early-pay-calculator-plan-plate.component';

interface SubscriptionPlanPanelData {
  planName: SubscriptionPlanName;
  price: number;
  upfrontFee: number;
  fee: number;
  eppIdealAmount: string;
}

@Component({
  selector: 'app-early-pay-calculator-plan-toggle',
  templateUrl: './early-pay-calculator-plan-toggle.component.html',
  styleUrls: ['./early-pay-calculator-plan-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FlexComponent, MatSlideToggleModule, EarlyPayCalculatorPlanPlateComponent],
})
export class EarlyPayCalculatorPlanToggleComponent {
  @Output() updateSubscriptionFee: EventEmitter<{ fee: number; upfrontFee: number }> = new EventEmitter<{
    fee: number;
    upfrontFee: number;
  }>();

  subscriptionPlans: Map<SubscriptionPlanName, SubscriptionPlanPanelData> = new Map<
    SubscriptionPlanName,
    SubscriptionPlanPanelData
  >([
    [
      'blue',
      {
        planName: 'blue',
        price: 0,
        upfrontFee: 1,
        fee: 0.4,
        eppIdealAmount: '100K',
      },
    ],
    [
      'gold',
      {
        planName: 'gold',
        price: 1750,
        upfrontFee: 0.75,
        fee: 0.35,
        eppIdealAmount: '500K',
      },
    ],
    [
      'platinum',
      {
        planName: 'platinum',
        price: 3500,
        upfrontFee: 0.5,
        fee: 0.33,
        eppIdealAmount: '1M',
      },
    ],
  ]);

  selectedPlan: SubscriptionPlanName = 'blue';
  isAnnualSubscription = false;
  arePlansExpanded = false;

  toggleAnnualSubscription(checked: boolean): void {
    this.isAnnualSubscription = checked;
  }

  selectSubscriptionPlan(selectedPlan: SubscriptionPlanName): void {
    this.selectedPlan = selectedPlan;

    const fee = this.getSubscriptionFee(selectedPlan);
    const upfrontFee = this.getUpfrontFee(selectedPlan);
    this.updateSubscriptionFee.emit({
      fee,
      upfrontFee,
    });
  }

  togglePlansExpanding(shouldExpandPlans: boolean): void {
    this.arePlansExpanded = shouldExpandPlans;
  }

  getSubscriptionFee(plan: SubscriptionPlanName): number {
    switch (plan) {
      case 'blue':
        return 0.004;
      case 'gold':
        return 0.0035;
      case 'platinum':
        return 0.0033;
      default:
        throw new Error('Invalid subscription plan name');
    }
  }

  getUpfrontFee(plan: SubscriptionPlanName): number {
    switch (plan) {
      case 'blue':
        return 0.01;
      case 'gold':
        return 0.0075;
      case 'platinum':
        return 0.005;
      default:
        throw new Error('Invalid subscription plan name');
    }
  }
}
